import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M169.9 180.2c-9 6.3-19 10.7-29.4 13-13.3 3.3-26.8 4.9-40.4 4.8-13.6.1-27.2-1.5-40.5-4.8-10.4-2.3-20.4-6.7-29.4-13-7.2-5.5-10.8-11.4-10.8-17.8v-23.7c10.1 8.7 21.7 14.8 34.1 17.7 15.3 4.1 30.9 6.1 46.6 6 15.7.1 31.3-1.9 46.6-6 12.4-2.9 24.1-9 34.1-17.7v23.7c-.1 6.4-3.7 12.3-10.9 17.8zm0-53.5c-9 6.3-19 10.7-29.4 13-13.3 3.3-26.9 4.9-40.4 4.8-13.6.1-27.2-1.5-40.4-4.8-10.4-2.3-20.4-6.7-29.4-13-7.2-5.5-10.8-11.4-10.8-17.8V85.2C29.4 94 41 100 53.4 102.9c15.3 4.1 30.9 6.1 46.6 6 15.7.1 31.3-1.9 46.5-6 12.4-2.9 24.1-8.9 34.1-17.6V109c.1 6.3-3.5 12.2-10.7 17.7zm0-53.4c-9 6.3-19 10.7-29.4 13-13.3 3.3-26.9 4.9-40.4 4.8-13.6.1-27.2-1.5-40.5-4.8-10.4-2.3-20.4-6.7-29.4-13-7.2-5.5-10.8-11.4-10.8-17.8V37.6c0-6.4 3.6-12.3 10.8-17.8 9.1-6.3 19-10.7 29.4-13C72.8 3.5 86.4 1.9 100 2c13.6-.1 27.2 1.5 40.4 4.8 10.4 2.3 20.4 6.7 29.4 13 7.2 5.5 10.8 11.4 10.8 17.8v17.8c.1 6.5-3.5 12.4-10.7 17.9z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}